<template>
  <a-config-provider :locale="locale">
    <MainPage/>
  </a-config-provider>
  
</template>

<script>

import MainPage from "@/page/MainPage";
import locale from 'ant-design-vue/es/locale/zh_CN'

export default {
  name: 'App',
  components: {
    MainPage,
  },
  data() {
    return {
      locale,
    }
  }
}
</script>

<style>
#app {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}
</style>
